import { Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { LoginService } from 'app/login/services/login.service';
import { Unsubscriber } from 'app/utils/angular-utils/classes';
import { takeUntil } from 'rxjs/operators';
import { ConfigManagerProperties } from '../enums/config-manager-properties.enum';

@Injectable()
export class IdleTimeoutService {
  private timeInSecs: number;
  private unsubscriber = new Unsubscriber();

  constructor(private idle: Idle, private config: ConfigManagerService, private loginService: LoginService) {
    this.timeInSecs = this.config.getSetting<number>(ConfigManagerProperties.idleTimeInSec);
    this.idle.setIdle(this.timeInSecs);
    this.idle.setTimeout(this.timeInSecs);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.onTimeout.pipe(takeUntil(this.unsubscriber.done)).subscribe(() => {
      this.loginService.clear();
      this.idle.stop();
    });

    this.loginService
      .getLoggedInUser(this.config.getSetting<string>(ConfigManagerProperties.loggedInUserRoot))
      .pipe(takeUntil(this.unsubscriber.done))
      .subscribe(() => {
        this.start();
      });

    this.loginService.userLoggedIn$.pipe(takeUntil(this.unsubscriber.done)).subscribe(() => {
      this.start();
    });
  }

  public start() {
    this.idle.watch();
  }

  public stop() {
    this.idle.stop();
    this.idle.clearInterrupts();
    this.unsubscriber.complete();
  }
}
